var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvertising(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.25,2.5 L16.25,17.5 L3.75,17.5 L3.75,2.5 L16.25,2.5 L16.25,2.5 Z M16.25,1.25 L3.75,1.25 C3.05964406,1.25 2.5,1.80964406 2.5,2.5 L2.5,17.5 C2.5,18.1903559 3.05964406,18.75 3.75,18.75 L16.25,18.75 C16.9403559,18.75 17.5,18.1903559 17.5,17.5 L17.5,2.5 C17.5,1.80964406 16.9403559,1.25 16.25,1.25 Z M5.625,14.375 L6.875,14.375 L6.875,15.625 L5.625,15.625 L5.625,14.375 Z M13.125,14.375 L14.375,14.375 L14.375,15.625 L13.125,15.625 L13.125,14.375 Z M5.625,11.25 L6.875,11.25 L6.875,12.5 L5.625,12.5 L5.625,11.25 Z M13.125,11.25 L14.375,11.25 L14.375,12.5 L13.125,12.5 L13.125,11.25 Z M5.625,8.125 L6.875,8.125 L6.875,9.375 L5.625,9.375 L5.625,8.125 Z M9.375,14.375 L10.625,14.375 L10.625,15.625 L9.375,15.625 L9.375,14.375 Z M9.375,11.25 L10.625,11.25 L10.625,12.5 L9.375,12.5 L9.375,11.25 Z M9.375,8.125 L10.625,8.125 L10.625,9.375 L9.375,9.375 L9.375,8.125 Z M13.125,8.125 L14.375,8.125 L14.375,9.375 L13.125,9.375 L13.125,8.125 Z M5.625,4.375 L14.375,4.375 L14.375,6.25 L5.625,6.25 L5.625,4.375 Z",
    id: "path-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image/calculator/20",
    transform: "translate(-2.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon-color",
    fill: "#194A74",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertising);
export default __webpack_public_path__ + "static/media/Advertising.3ab7708b.svg";
export { ForwardRef as ReactComponent };